import { useNamespace } from 'components/templates/Translation/TranslationWrapper';
import { useTenant } from 'hooks/useTenant';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';
import React from 'react';

export interface MetaData {
  title: string;
  description: string;
  imageUrl?: string;
  isTranslated?: true;
}

export interface Props {
  metaData?: MetaData;
  shouldIndexPage?: boolean;
  locales?: string[];
}

export function createPageMetaData(siteName: string) {
  return function PageMetaData({ metaData, shouldIndexPage }: Props) {
    const namespace = useNamespace();
    const { t } = useTranslation(namespace);
    const title = t(`${metaData?.title || 'Welcome'} | {{siteName}}`, { siteName });
    const description = t(metaData?.description || 'Welcome to {{siteName}}', { siteName });
    const defaultImageUrl = useTenant({
      mobiworkx: '/assets/mobiworkx-firebase-image.png',
    });

    // Always stop portal Lifepoints and Mobiworkx pages from being indexed, but allow certain Qmee pages
    const shouldNoIndex = useTenant({
      qmee: shouldIndexPage === false,
      mobiworkx: true,
      lifepoints: true,
    });
    const imageUrl = metaData?.imageUrl ? metaData.imageUrl : defaultImageUrl;

    return (
      <>
        {metaData && (
          <Head>
            <link rel="preconnect" href={process.env.NEXT_PUBLIC_GATEWAY_URL} />
            <title>{`${title}`}</title>
            <meta name="description" content={description} />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            {imageUrl && <meta property="og:image" content={imageUrl} />}
          </Head>
        )}

        {shouldNoIndex && (
          <Head>
            <meta name="robots" content="noindex" />
          </Head>
        )}
      </>
    );
  };
}
